import HEADER from "../Components/header";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useEffect, useState} from "react";
import {ApiRequest} from "../Consts/ApiRequest";
import baseUrlApi from "../lib/baseUrlApi";
import {useCookies} from "react-cookie";

type Param = {
    siteId?: string,
    siteRecno?: string,
    controlID?: string
}

const Topmenu = () => {
    const navigate = useNavigate();
    const [siteName, setSiteName] = useState<string>("");
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const params: Param = useParams<Param>();
    const siteId = params.siteId;
    const siteRecno = params.siteRecno;
    const controlID = params.controlID;

    const handleSensorConfigClick = () => {
        navigate(`/sensor_config/${siteId}/${siteRecno}`);
    };
    const handleEnvSettingClick = () => {
        navigate(`/env_setting/${siteId}/${siteRecno}`);
    };
    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    useEffect(() => {
        if(cookies.authority == 4) {
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        var params = {
            siteId: siteId ?? "",
                siteRecno: siteRecno ?? ""
        };
        const token = cookies.access_token || "";
        ApiRequest.getSiteSetting(params, token, (response: any) => {
            setSiteName(response.data.siteName);
        }, (error: any) =>{
            errorCallback(error);
        });
    });

    return (
        <div className="wrapper">
            <HEADER
                siteName={siteName}
                siteId={siteId}
                siteRecno={siteRecno}
            />
            <main className="main">
                <section className="page-head" id="page-head">
                    <div className="page-head-block">
                        <div className="page-name">
                            <a onClick={() => navigate(-1)}><img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" /></a>
                            <div className="page-name-label">メニュー</div>
                        </div>
                    </div>
                </section>
                <section className="page-body scroll-block">
                    <div className="menu-box">
                        <button onClick={handleSensorConfigClick} className="menu-item menu-sensor">センサ設定</button>
                        <button onClick={handleEnvSettingClick} className="menu-item menu-environment">
                            環境設定</button>

                        <Link to={`/download/${siteId}/${siteRecno}/`} className="menu-item menu-download">
                            データダウンロード
                        </Link>
                    </div>
                </section>
            </main>
        </div>
    );
};
export default Topmenu;
